module.exports = __webpack_public_path__ + "img/icon-holding.70541693.svg";